import React, { useEffect } from 'react';
import {
    Badge,
    Button,
    DropdownMenu,
    FiltersOutlined,
    Group,
    useDisclosure,
} from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { searchV3FilterType } from 'components/Filters/Filters';
import SearchToolsMobileDropdown from './SearchToolsMobileDropdown';
import useAdvancedFilter from './hooks/useAdvancedFilter';

const SearchToolsMobile = () => {
    const { isOpen, onClose, onOpen } = useDisclosure();

    const {
        setIsAdvancedFiltersMobileOpen,
        filtersAppliedTotal,
        availableAdvancedFilters,
    } = useAdvancedFilter();

    useEffect(() => {
        setIsAdvancedFiltersMobileOpen(isOpen);
    }, [isOpen, setIsAdvancedFiltersMobileOpen]);

    return (
        <DropdownMenu isOpen={isOpen} onOpen={onOpen}>
            <DropdownMenu.Trigger>
                <Button
                    variant="ghost"
                    isRounded
                    isFull
                    width="100%"
                    alignItems={'center'}
                    display={'flex'}
                >
                    <Group gap="xs" alignItems={'center'} display={'flex'}>
                        <Group.Item>
                            <FiltersOutlined />
                        </Group.Item>
                        <Group.Item>
                            <Trans>All filters</Trans>
                        </Group.Item>
                        {!!filtersAppliedTotal && (
                            <Group.Item alignItems={'center'} display={'flex'}>
                                <Badge
                                    label={filtersAppliedTotal.toString()}
                                    variant="inverted"
                                    isRounded
                                    size="sm"
                                />
                            </Group.Item>
                        )}
                    </Group>
                </Button>
            </DropdownMenu.Trigger>
            <DropdownMenu.List>
                <SearchToolsMobileDropdown
                    toolsType={searchV3FilterType.Types}
                    onClose={onClose}
                />
                <SearchToolsMobileDropdown
                    toolsType={searchV3FilterType.BPM}
                    onClose={onClose}
                />
                <SearchToolsMobileDropdown
                    toolsType={searchV3FilterType.Key}
                    onClose={onClose}
                />
                {Object.values(availableAdvancedFilters).map((filter) => {
                    return (
                        <SearchToolsMobileDropdown
                            toolsType={filter}
                            onClose={onClose}
                            filtersAppliedTotal={filtersAppliedTotal}
                            key={`mobile-${filter}`}
                        />
                    );
                })}
            </DropdownMenu.List>
        </DropdownMenu>
    );
};

export default SearchToolsMobile;
